import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import * as XLSX from "xlsx";

export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadDataFile',
  props: {
  sheetData: {
    type: Array,
    required: true,
  }
},
  setup(__props) {

const props = __props



const exportToExcel = () => {
  const { sheetData } = props;
  const fileName = `YNT-${new Date().toISOString()}.xlsx`;
  const ws = XLSX.utils.json_to_sheet(sheetData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'ynt-data');
  XLSX.writeFile(wb, fileName);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "sdds-btn sdds-btn-primary button-float-right",
    onClick: exportToExcel
  }, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})